import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useEnterGiveawayButton } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useEnterGiveawayButton';
import { useGiveawaySection, } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection';
import { memo } from 'react';
export const EnterGiveawayButton = memo(() => {
    const { onEnterGiveaway, isLoading } = useEnterGiveawayButton();
    const { isPickingWinner, isWaitTimeExpired } = useGiveawaySection();
    const isEnabled = !isPickingWinner && !isWaitTimeExpired;
    return (<ButtonNew onClick={() => onEnterGiveaway()} disabled={!isEnabled} className="h-12 w-52 flex items-center justify-center">
			{isLoading ? <LoadingCircles width={20} height={20}/> : (<span className="enter-giveaway uppercase font-bold">Enter giveaway</span>)}
		</ButtonNew>);
});
